import { safeClone, SpyneTrait } from "spyne";
import {
  compose,
  concat,
  filter,
  fromPairs,
  head,
  isEmpty,
  join,
  mergeLeft,
  pick,
  reject,
  values,
  whereEq,
  zip,
} from "ramda";
import { UtilTraits } from "traits/util-traits";

export class PageDocsTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "pageDocs$";

    super(context, traitPrefix);
  }

  static pageDocs$HelloWorld() {
    return "Hello World";
  }

  static pageDocs$ConformDocsData(data = this.props.data) {
    return data;
  }

  static pageDocs$CreateMenuData(data = this.props.data) {
    // const levels = ['pageId', 'stage', 'section', 'topic', 'subtopic', 'aside'];

    const levels = PageDocsTraits.pageDocs$GetDocLevelsArray();

    const createObj = (arr) => {
      const endRoute = arr.length < 5;
      return compose(mergeLeft({ endRoute }), fromPairs, zip(levels))(arr);
    };

    let recursiveIter = 0;
    let oldNum = false;

    // CURRIED REDUCE METHOD - UPDATES pathsArr BASED ON ARRAY DEPTH
    const reduceToPathsObj = (pathsArr) => {
      // USED TO CHECK ARRAY DEPTH
      const num = Math.random();

      return (acc, o) => {
        let { menuLabel, content } = o;

        if (menuLabel !== undefined) {
          const isNewNum = num !== oldNum && pathsArr.length >= 1;
          recursiveIter = isNewNum ? (recursiveIter += 1) : recursiveIter;
          pathsArr = pathsArr.slice(0, recursiveIter).concat(menuLabel);
          acc.push(createObj(pathsArr));
        }

        if (Array.isArray(content)) {
          oldNum = num;
          content.reduce(reduceToPathsObj(pathsArr), acc);
        }

        return acc;
      };
    };

    return data.reduce(reduceToPathsObj([]), []);
  }
  static pageDocs$CreateId(menuData = "", length = 8) {
    const { itemType, section, stage, pageId } = menuData;
    //console.log("MENU DATA ",{itemType,menuData, pageId, stage, section})

    const createStageAndSectionId = () => {
      const reduceToId = (acc = "", str) => {
        if (str) {
          acc += `-${str}`;
        }
        return acc;
      };

      return [stage, section].reduce(reduceToId, pageId);
    };

    const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
    return ["stage", "section"].includes(itemType)
      ? createStageAndSectionId()
      : `${itemType}-${Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join("")}`;
  }

  static pageDocs$GetDocLevelsArray() {
    return [
      "pageId",
      "stage",
      "container",
      "section",
      "topic",
      "subtopic",
      "aside",
    ];
  }

  static pageDocs$AddMenuData(data = this.props.data) {
    const levels = PageDocsTraits.pageDocs$GetDocLevelsArray();

    const contentArr = [];

    const createObj = (arr) => {
      const endRoute = arr.length < 5;
      const contentLevel = arr.length;
      const itemType = levels[contentLevel - 1];
      return compose(
        mergeLeft({ endRoute, itemType, contentLevel }),
        fromPairs,
        zip(levels),
      )(arr);
    };

    let recursiveIter = 0;
    let oldNum = false;

    let binaryIncrement = -1;
    let binaryIncrementCheck = -1;

    // CURRIED REDUCE METHOD - UPDATES pathsArr BASED ON ARRAY DEPTH
    const reduceToPathsObj = (pathsArr) => {
      // USED TO CHECK ARRAY DEPTH
      const num = Math.random();

      return (o, i) => {
        let { menuLabel, content } = o;

        if (i === 0 && menuLabel !== undefined) {
          binaryIncrement += 1;
        }

        let isNewNum = false;

        if (menuLabel !== undefined) {
          //isNewNum = num !== oldNum && pathsArr.length >= 1;
          //recursiveIter  = isNewNum ? recursiveIter+=1 : recursiveIter;
          pathsArr = pathsArr.slice(0, binaryIncrement).concat(menuLabel);
        }

        const menuData = createObj(pathsArr);
        menuData["isMenuItem"] = menuLabel !== undefined;

        o["menuData"] = menuData;
        o["itemId"] = PageDocsTraits.pageDocs$CreateId(o);
        //console.log("PATHS ARR ",{ i, binaryIncrement}, o.menuLabel, ['pageId', 'stage', 'section', 'topic', 'subtopic'][binaryIncrement])

        // const copyObj = omit(['content'], o);
        const copyObj = safeClone(o);
        delete copyObj.content;
        contentArr.push(copyObj);

        if (Array.isArray(content)) {
          oldNum = num;
          content.map(reduceToPathsObj(pathsArr));
        }

        return o;
      };
    };

    data.map(reduceToPathsObj([]));

    return contentArr;
  }

  static pageDocs$GetDataObjByRouteData(routeData = {}, docsData = {}) {
    /*    routeData = {
      "pageId": "docs",
      "stage": "build",
      "section": "viewstream",
      "topic": "viewstream-selector",
      "subtopic" : "",
      "eventPreventDefault": "true"
    }*/

    const levelsArr = PageDocsTraits.pageDocs$GetDocLevelsArray();

    const dataObj = compose(reject(isEmpty), pick(levelsArr))(routeData);

    // routeData = {pageId: 'docs', stage: 'build', section: 'spynetraits', topic: 'spynetraits-prefix'};
    const routePred = (o) => whereEq(dataObj, o.menuData);
    const filterDocItems = compose(head, filter(routePred))(docsData);
   //console.log'docs item ', {dataObj, docsData, filterDocItems});

    return filterDocItems;
  }

  static pageDocs$CreateMenuUrl(obj) {
    return compose(concat("/"), join("/"), values)(obj);
  }
  static pageDocs$CreateMenuId(obj) {
    return compose(join("-"), values)(obj);
  }
  static pageDocs$CreateMenuDataObj(pathsArr, iter = 0) {
    //const levels = ['pageId', 'stage', 'section', 'topic', 'subtopic', 'aside'];
    const levels = PageDocsTraits.pageDocs$GetDocLevelsArray();

    const endRoute = pathsArr.length < 5;
    const contentLevel = pathsArr.length;
    const itemType = levels[contentLevel - 1];
    const menuDataset = compose(fromPairs, zip(levels))(pathsArr);
    const menuId = `docs-item-${iter}`; // PageDocsTraits.pageDocs$CreateMenuId(menuDataset);
    menuDataset["url"] = PageDocsTraits.pageDocs$CreateMenuUrl(menuDataset);

    return Object.assign(
      { endRoute, itemType, menuId, contentLevel, menuDataset },
      menuDataset,
    );
    //return compose(mergeLeft({endRoute,itemType, contentLevel}),fromPairs, zip(levels))(pathsArr);
  }

  static pageDocs$CreateDocsData(data = this.props.data.spyneDocsData) {
    const docItemsArr = [];

    let idIter = 0;

    const mapToLabel = (o) => {
      const { parentLabel, menuLabel, content } = o;
      const menuLabelUrl = UtilTraits.utils$formatForUrl(menuLabel);

      if (parentLabel) {
        o["labelsArrs"] = String(`${parentLabel}@@${menuLabelUrl}`).split("@@");
        idIter += 1;
        o["menuData"] = PageDocsTraits.pageDocs$CreateMenuDataObj(
          o.labelsArrs,
          idIter,
        );
        o["menuDataPath"] = UtilTraits.utils$formatForUrl(o.menuLabel);

        o["itemId"] = PageDocsTraits.pageDocs$CreateId(o.menuData);
        o["sidebarTitle"] = o.sidebarTitle || o.title;

        const copyObj = safeClone(o);
        delete copyObj.content;
        docItemsArr.push(copyObj);
      }

      if (content) {
        const addParentLabel = (o) => {
          o["parentLabel"] =
            parentLabel !== undefined
              ? parentLabel + "@@" + menuLabelUrl
              : menuLabelUrl;
          //if (o.parentLabel.includes("ViewStream")){
          //console.log("PARENT LABEL ",o.parentLabel);
          // }

          return o;
        };
        content.map(addParentLabel);
        content.map(mapToLabel);
      }

      return o;
    };
    //console.log("DATA IS ",data[0]);

    // return data;
    try {
      data.map(mapToLabel);
    } catch (e) {
      //console.warn("PAGE DOCS ERR ON MAP LINE 245", { data, e });
    }
    return docItemsArr;
  }
}
